<template>
  <empty-card
    :mainText="$t('page.dashboard.addLocationAndTerminal')"
    :buttonText="$t('common.action.addANewLocation')"
    :buttonColor="'primary'"
    @button-click="createLocation()"
  >
    <template #image>
      <v-img
        src="@/shared/assets/addTerminal.png"
        max-height="150px"
        min-height="75px"
      /> </template
  ></empty-card>
  <location-dialog ref="dialog" dialogAction="create" @updated="handleLocationAdded()" />
</template>

<script lang="ts" setup>
import { ref } from "vue";
import LocationDialog from "@/terminals/components/location-and-terminals/LocationDialog.vue";
import { useLocationStore } from "@/terminals/stores/locations";
import EmptyCard from "@/shared/components/Common/EmptyCard.vue";
const dialog = ref<null | { open: (id?: string) => null }>(null);
const handleLocationAdded = async () => {
  await useLocationStore().listLocations(false);
};
const createLocation = async () => {
  dialog.value?.open();
};
</script>
